const weatherConditionMappings: Record<string, string> = {
  'clear': 'ясно', // IconClear
  'partly-cloudy': 'малооблачно', // IconSemiCloudy
  'cloudy': 'облачно с прояснениями', // IconSunCloudy
  'overcast': 'пасмурно', // IconCloudy
  'drizzle': 'морось', // IconDrizzle
  'light-rain': 'небольшой дождь', // IconSemiRain
  'rain': 'дождь', // IconRain
  'moderate-rain': 'умеренно сильный дождь', // IconSemiPowerRain
  'heavy-rain': 'сильный дождь', // IconPowerRain
  'continuous-heavy-rain': 'длительный сильный дождь', // IconPowerTimelessRain
  'showers': 'ливень', //  IconDownpour
  'wet-snow': 'дождь со снегом', // IconSnowRain
  'light-snow': 'небольшой снег', // IconSnowLittle
  'snow': 'снег', // IconSnow
  'snow-showers': 'снегопад', // IconSnowHard
  'hail': 'град', // IconHail
  'thunderstorm': 'гроза', // IconThunder
  'thundersworm-with-rain': 'дождь с грозой', // IconThunderRain
  'thundersworm-with-hail': 'гроза с градом', // IconThunderHail
};

export const getWeatherConditionLabel = (condition: string) => {
  return weatherConditionMappings[condition];
};
